module.exports = __webpack_public_path__ + "static/media/everyday-information-architecture.ce3db1aa.png";